import PropTypes from 'prop-types';

import Link from 'bloko/blocks/link';

const ManagerLink = ({ managerEmail }) => <Link href={`mailto:${managerEmail}`}>{managerEmail}</Link>;

ManagerLink.propTypes = {
    managerEmail: PropTypes.string,
};

export default ManagerLink;
